import { render, staticRenderFns } from "./CompetitionNoSchool.vue?vue&type=template&id=17000459&scoped=true&"
import script from "./CompetitionNoSchool.vue?vue&type=script&lang=js&"
export * from "./CompetitionNoSchool.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionNoSchool.vue?vue&type=style&index=0&id=17000459&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17000459",
  null
  
)

export default component.exports